const pageNameKey = "renderUnreleasedFeaturesInfo";

export const renderUnreleasedFeaturesInfoEn = {
  [pageNameKey]: {
    toolTipText:
      "Unreleased features are features that are not yet available to the public. (Click to toggle border)",
    infoText: "Render unreleased features",
  },
};

export const renderUnreleasedFeaturesInfoPtBr = {
  [pageNameKey]: {
    toolTipText:
      "Recursos não lançados são recursos que ainda não estão disponíveis ao público. (Clique para alternar a borda)",
    infoText: "Renderizar recursos não lançados",
  },
};

export const renderUnreleasedFeaturesInfoDe = {
  [pageNameKey]: {
    toolTipText:
      "Unveröffentlichte Funktionen sind Funktionen, die noch nicht für die Öffentlichkeit verfügbar sind. (Klicken, um den Rand umzuschalten)",
    infoText: "Unveröffentlichte Funktionen darstellen",
  },
};

export const renderUnreleasedFeaturesInfoZhHans = {
  [pageNameKey]: {
    toolTipText: "未发布的功能是尚未向公众提供的功能。（点击切换边框）",
    infoText: "渲染未发布的功能",
  },
};

export const renderUnreleasedFeaturesInfoIt = {
  [pageNameKey]: {
    toolTipText:
      "Funzionalità che non sono ancora disponibili al pubblico. (Fai clic per attivare il bordo)",
    infoText: "Visualizza le funzionalità non rilasciate",
  },
};

export const renderUnreleasedFeaturesInfoEs = {
  [pageNameKey]: {
    toolTipText:
      "Las funciones no publicadas son funciones que aún no están disponibles para el público. (Haz clic para alternar el borde)",
    infoText: "Mostrar funciones no publicadas",
  },
};

export const renderUnreleasedFeaturesInfoNl = {
  [pageNameKey]: {
    infoText: "Niet-gepubliceerde functies weergeven",
    toolTipText:
      "Niet-gepubliceerde functies zijn functies die nog niet beschikbaar zijn voor het publiek. (Klik om de rand weer te geven/verbergen)",
  },
};

export const renderUnreleasedFeaturesInfoTr = {
  [pageNameKey]: {
    infoText: "Yayınlanmamış özellikleri işle",
    toolTipText:
      "Yayınlanmamış özellikler, henüz genel kullanıma sunulmamış özelliklerdir. (Sınırları değiştirmek için tıklayın)",
  },
};
